export const RELATION_LIST_SUCCESS = "RELATION_LIST_SUCCESS";
export const EMERGENCY_CONTACT_LOADER_VISIBILITY =
  "EMERGENCY_CONTACT_LOADER_VISIBILITY";

export const GET_MERGENCY_DATA_SUCCESS = "GET_MERGENCY_DATA_SUCCESS";
